import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PaymentSuccessful = ({ topUpAmount, show, onHide, props }) => {
    const { role } = useSelector((state) => state.auth.user);

    var billing_log_path;

    if (role === "manager"){
        billing_log_path = "/manager/dashboard/account/billing-log";
    }
    
    if (role === "user"){
        billing_log_path = "/dashboard/account/billing-log";
    }

    return (
        <Modal
            show={show}
            onHide={() => onHide(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                <div className="VerificationPage VerifiedVerification">
                    <div className="page-content text-center">
                        <img src={require('../../assets/elfo-mascot-logo.png')} alt="..." />

                        <h3>Congratulations! Your Payment was successful!</h3>

                        <p>Your account has been credited. Thank you for choosing our services.</p>

                        <p>All of your billing details are located in the Billing Log. Go there by clicking the button below.</p>
                        <Link
                            className="btn btn-primary"
                            to={billing_log_path}
                            style={{ display: 'inline-flex', minWidth: 160 }}
                        >
                            Billing Log
                        </Link>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
};
export default PaymentSuccessful